import React,{useEffect,useState} from 'react';
import {api} from '@/lib/api';
import FilledNavigationGlyph from './toto/FilledNavigationGlyph';
/** Receives an authorized canonical employee, never a name-based identity match.
 * No folder-specific image storage and no protected API URL in the rendered DOM.
 * Photo reads use the existing People directory scope and private caching.
 */
export default function EmployeeFolderPhoto({employee}){
 const [photo,setPhoto]=useState(null);
 const uid=employee?.user_id,picture=employee?.picture;
 useEffect(()=>{
  let active=true,url=null,generation=0;
  const release=()=>{if(url){URL.revokeObjectURL(url);url=null;}};
  const load=async()=>{const request=++generation;if(!uid){setPhoto(null);return;}try{
   const {data}=await api.get(`/employees/${encodeURIComponent(uid)}/photo/content`,{responseType:'blob',headers:{'Cache-Control':'no-cache'}});
   if(!active||request!==generation)return;
   if(!(data instanceof Blob)||!/^image\/(png|jpeg|jpg|webp|gif|svg\+xml)$/.test(data.type))throw new Error('Unsupported photo');
   release();url=URL.createObjectURL(data);setPhoto({uid,url});
  }catch{if(active&&request===generation){release();setPhoto(null);}}};
  setPhoto(null);load();window.addEventListener('focus',load);
  return()=>{active=false;++generation;window.removeEventListener('focus',load);release();};
 },[uid,picture]);
 const current=photo?.uid===uid?photo:null;
 return current?<img className="employee-folder-photo" src={current.url} alt={`Profile photo for ${employee.name}`} decoding="async" referrerPolicy="no-referrer" onError={()=>{URL.revokeObjectURL(current.url);setPhoto(null);}}/>:<span className="folder-review__portrait" aria-label={`No profile photo available for ${employee?.name||'employee'}`}><FilledNavigationGlyph name="profile" size={48}/></span>;
}
